import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import { mechanicHierarchyInformationPropTypes } from '../proptypes/MechanicPropTypes';
import { MECHANIC_EMPLOYEE_TYPE } from '../../../../../config/constants';
import { DATE_FORMAT } from '../../../../../config/locale';
import { tzNormalizeDate } from '../../../../../utils/date';

const MechanicHierarchyInformationResource = ({
  management,
  department,
  area,
  section,
  speciality,
  employeeType,
  terminationDate,
}) => (
  <>
    <ResourceProperty label="Gerencia:">
      {management ? management.name : '-'}
    </ResourceProperty>

    <ResourceProperty label="Departamento:">
      {department ? department.name : '-'}
    </ResourceProperty>

    <ResourceProperty label="Área:">{area ? area.name : '-'}</ResourceProperty>

    <ResourceProperty label="Sección:">
      {section ? section.name : '-'}
    </ResourceProperty>

    <ResourceProperty label="Especialidad:">
      {speciality ? speciality.name : '-'}
    </ResourceProperty>

    <ResourceProperty label="Tipo de Empleado:">
      {employeeType && MECHANIC_EMPLOYEE_TYPE[employeeType]
        ? MECHANIC_EMPLOYEE_TYPE[employeeType].label
        : '-'}
    </ResourceProperty>

    <ResourceProperty label="Fecha de Cese:">
      {terminationDate
        ? tzNormalizeDate({ date: terminationDate, format: DATE_FORMAT })
        : '-'}
    </ResourceProperty>
  </>
);

MechanicHierarchyInformationResource.propTypes =
  mechanicHierarchyInformationPropTypes;

export default MechanicHierarchyInformationResource;
